export default class Constants {
  public static readonly mimeTypeHls = 'application/vnd.apple.mpegurl';
  public static readonly miEmbededPlayerApiUrl = 'https://d.video-cdn.net/play';
  public static readonly miEmbededPlayerJsUrl = 'https://e.video-cdn.net/v2/embed.js';
  public static readonly videoDefaultAspectRatio = 1920 / 1080;
}